import {ButtonProps} from '../button/Button'
import {StyledConfirmationDialogAccordionButton} from './style'

export const ConfirmationDialogAccordionButton = (props: ButtonProps) => (
    <StyledConfirmationDialogAccordionButton {...props} />
)
